/**
 * Created by Mark on 17/04/2017.
 */




import React  from 'react';
import CurriculumServices from '../services/curriculums-services.js';
import CurriculumStore from '../store/curriculum-store.js';
import Layout from '../components/layouts/standard-page.js';
import Card from '../components/card.js';
import CardBody from '../components/card-body.js';
import CardHeader from '../components/card-header.js';

export default class SongsComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {email:'', loaded:true , list:[]}
    }


    getBackground = function(){

        var getLevel = function(uid){
            return 1 + Math.floor(uid / 6);
        };

        switch(String(getLevel(this.props.params.unitID)))
        {
            case  '1' :  return ('farm'); break;
            case  '2' :  return ('school'); break;
            case  '3' :  return ('beach'); break;
            case  '4' :  return ('school'); break;
            default : return ('school'); break;
        }
    };

    
    render(){
        return (<Layout>
                   <Card class={this.getBackground()}>

                       <CardBody>
                           <center>
                                <iframe frameborder="0" allowtransparency="true" height="500" style={{padding:0 , width:"100%" ,  border:"none"}} src = {"archive/?mode=Songs&unit="+(Number(this.props.params.unitID) - 1)+"&language="+this.props.params.languagePrefix} />
                           </center>
                       </CardBody>
                   </Card>
                </Layout>);
    }
}


// WEBPACK FOOTER //
// ./src/screens/songs.js